import { extendTheme, theme as coreTheme } from '@chakra-ui/core';
import { createBreakpoints } from '@chakra-ui/theme-tools';
import colors from './colors';
import { avatarWidth } from './sizes';

// 2. Update the breakpoints as key-value pairs
const breakpoints = createBreakpoints({
  sm: '320px',
  md: '768px',
  lg: '1045px',
  xl: '1200px',
});

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
const theme = extendTheme({
  fonts: {
    body: 'Helvetica',
  },
  components: {
    Avatar: {
      sizes: {
        sm: {
          container: {
            width: avatarWidth.sm,
            height: avatarWidth.sm,
          },
        },
        md: {
          container: {
            width: avatarWidth.md,
            height: avatarWidth.md,
          },
        },
        lg: {
          container: {
            width: avatarWidth.lg,
            height: avatarWidth.lg,
          },
        },
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            border: '1px',
            borderColor: colors.dividerGray,
          },
        },
        filled: {
          field: {
            border: '1px',
            borderColor: colors.input.borderColor,
            background: colors.input.background,
            _hover: {
              background: colors.input.hoverBackground,
            },
            _placeholder: {
              color: colors.input.placeholderColor,
              fontSize: 'md',
            },
          },
        },
      },
    },
    Select: {
      variants: {
        filled: {
          wrapper: {
            width: 'fit-content',
          },
          field: {
            border: '1px',
            borderColor: colors.input.borderColor,
            background: colors.input.background,
            borderRadius: 'md',
            _hover: {
              background: colors.input.hoverBackground,
            },
            _placeholder: {
              color: colors.input.placeholderColor,
              fontSize: 'md',
            },
          },
        },
      },
    },
    Button: {
      variants: {
        square: (props?: React.CSSProperties) => ({
          ...coreTheme.components.Button.variants.ghost(props!),
          // aspectRatio: '1/1',
          padding: 0,
        }),
      },
    },
    MenuItem: {
      baseStyle: {
        _hover: {
          bg: 'gray.100',
        },
      },
    },
  },
  colors: {
    ...colors,
    neutralGray: {
      ...colors.neutralGray,
    },
    red: {
      ...colors.red,
    },
    orange: {
      ...colors.orange,
    },
    lightBlue: {
      ...colors.lightBlue,
    },
    green: {
      ...colors.green,
    },
    cyan: {
      ...colors.cyan,
    },
  },
  shadows: {
    '2xl': '0px 24px 24px rgba(0, 0, 0, 0.24), 0px 0px 24px rgba(0, 0, 0, 0.12)',
  },
  breakpoints,
});

export default theme;
